import { render } from "./CustomerChangeLogList.vue?vue&type=template&id=3d0bb864"
import script from "./CustomerChangeLogList.vue?vue&type=script&lang=js"
export * from "./CustomerChangeLogList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ambientaly/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__